/**
 * proofreading_chars として GA に送る文字数帯域。
 * 下限 inclusive / 上限 exclusive（例: 5000 → "5K-10K"）。
 */
export type ProofreadingCharsBand =
  | "0-5K"
  | "5K-10K"
  | "10K-30K"
  | "30K-80K"
  | "80K-130K"
  | "130K-300K"
  | "300K-1M"
  | "1M-MORE";

const CHAR_BANDS: ReadonlyArray<{ max: number; band: ProofreadingCharsBand }> = [
  { max: 5_000, band: "0-5K" },
  { max: 10_000, band: "5K-10K" },
  { max: 30_000, band: "10K-30K" },
  { max: 80_000, band: "30K-80K" },
  { max: 130_000, band: "80K-130K" },
  { max: 300_000, band: "130K-300K" },
  { max: 1_000_000, band: "300K-1M" },
];

export function toProofreadingCharsBand(chars: number): ProofreadingCharsBand {
  const value = Number.isFinite(chars) ? Math.max(0, chars) : 0;
  return CHAR_BANDS.find(({ max }) => value < max)?.band ?? "1M-MORE";
}
